import React, { useEffect, useState } from "react";
import { Empresa } from "../../../Models/Cadastros/Empresa/Empresa";
import DropDownListComponent from "../../../Components/Forms/DropDownListComponent";
import TextFieldComponent from "../../../Components/Forms/TextFieldComponent";
import Button from 'react-bootstrap/Button';
import axios from "axios";

const EmpresaDadosTab = (props: any) => {
    const [empresa, setEmpresa] = useState<any>(new Empresa());
    const [ufs, setUfs] = useState<any[]>([]);
    const [empresaTipos, setEmpresaTipos] = useState<any[]>([]);

    useEffect(() => {
        setEmpresa(props.empresa);
    }, [props.empresa]);

    useEffect(() => {
        (async () => {
            let response: any = await axios.get('buscaComboEmpresaTipos');
            setEmpresaTipos(response.data);
        })();
    }, []);

    useEffect(() => {
        (async () => {
            let responseUfs: any = await axios.get('buscaEstados');
            setUfs(responseUfs.data);
        })();
    }, []);
    
    return (
        <div className="row">
            <div className="col-md-3 mb-3">
                <TextFieldComponent
                    required
                    label="Nome Fantasia"
                    field='nome_fantasia'
                    model={empresa} />
            </div>

            <div className="col-md-3 mb-3">
                <TextFieldComponent
                    required
                    label="Razão Social"
                    field='razao_social'
                    model={empresa} />
            </div>

            <div className="col-md-3 mb-3">
                <TextFieldComponent
                    required
                    label="CNPJ"
                    field='cnpj'
                    model={empresa} />
            </div>

            <div className="col-md-3 mb-3">
                <TextFieldComponent
                    required
                    label="Unidade"
                    field='unidade'
                    model={empresa} />
            </div>

            <div className="col-md-3 mb-3">
                <TextFieldComponent
                    label="Código"
                    field='codigo'
                    model={empresa} />
            </div>

            <div className="col-md-3 mb-3">
                <DropDownListComponent
                    label='Tipo'
                    required
                    options={empresaTipos}
                    valueField='id'
                    textField='descricao'
                    model={empresa}
                    modelField='tipo_id' />
            </div>

            <div className="col-md-3 mb-3">
                <TextFieldComponent
                    required
                    label="Código Cliente"
                    field='codigo_cliente'
                    model={empresa} />
            </div>

            <div className="col-md-3 mb-3">
                <TextFieldComponent
                    required
                    label="Telefone 1"
                    field='telefone_1'
                    model={empresa} />
            </div>

            <div className="col-md-3 mb-3">
                <TextFieldComponent
                    label="Telefone 2"
                    field='telefone_2'
                    model={empresa} />
            </div>

            <br/>
            <h6>Endereço</h6>
            <br/>

            <div className="col-md-3 mb-3 mt-3">
                    <TextFieldComponent
                        required
                        label="CEP"
                        field='end_cep'
                        model={empresa}
                        className="col-md-6" />

                 {/* <button className="col-md-6">Buscar</button> Pelo que entendi não existe esse componente ainda*/}
            </div>

            <div className="col-md-3 mb-3 mt-3">
                <TextFieldComponent
                    required
                    label="Rua"
                    field='end_rua'
                    model={empresa} />
            </div>

            <div className="col-md-3 mb-3 mt-3">
                <TextFieldComponent
                    required
                    label="Número"
                    field='end_numero'
                    model={empresa} />
            </div>

            <div className="col-md-3 mb-3 mt-3">
                <TextFieldComponent
                    label="Complemento"
                    field='end_complemento'
                    model={empresa} />
            </div>

            <div className="col-md-3 mb-3">
                <TextFieldComponent
                    required
                    label="Bairro"
                    field='end_bairro'
                    model={empresa} />
            </div>

            <div className="col-xl-3 col-lg-3 col-md-3 col-sm-9 col-12  mb-3">
                <TextFieldComponent
                    required
                    label="Cidade"
                    field='end_cidade'
                    model={empresa} />
            </div>

            <div className="col-xl-3 col-lg-3 col-md-2 col-sm-3 col-12  mb-2">
                <DropDownListComponent
                    label='UF'
                    required
                    options={ufs}
                    valueField='id'
                    textField='sigla'
                    model={empresa}
                    modelField='end_uf_id' />
            </div>

            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 mb-5">
               <Button className="col-12" variant="secondary">Atualizar Mapa com Endereço</Button>
            </div>

            <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-6 mb-3">
                <TextFieldComponent
                    label="Latitude"
                    field='latitude'
                    model={empresa} />
            </div>

            <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-6 mb-3">
                <TextFieldComponent
                    label="Longitude"
                    field='longitude'
                    model={empresa} />
            </div>

            <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-6 mb-3">
                <TextFieldComponent
                    label="Tempo de Permanência"
                    field='tempo_min_permanencia'
                    model={empresa} />
            </div>

            <div className="col-xl-3 col-lg-3 col-md-2 col-sm-6 col-6 mb-3">
                <TextFieldComponent
                    label="Raio (mt)"
                    field='raio'
                    model={empresa} />
            </div>

            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12">
               <Button className="col-12" variant="secondary">Atualizar Mapa com Coordenadas</Button>
            </div>
            
            <br/>

            <br/>
            <h6>Endereço</h6>
            <br/>

            <div className="col-md-3 mb-3 mt-3">
                <TextFieldComponent
                    label="Responsável"
                    field='end_cep'
                    model={empresa}
                    className="col-md-6" />
            </div>

            <div className="col-md-3 mb-3 mt-3">
                <TextFieldComponent
                    label="Cargo"
                    field='responsavel_cargo'
                    model={empresa} />
            </div>

            <div className="col-md-3 mb-3 mt-3">
                <TextFieldComponent
                    label="Telefone"
                    field='responsavel_telefone'
                    model={empresa} />
            </div>

            <div className="col-md-3 mb-3 mt-3">
                <TextFieldComponent
                    label="Celular"
                    field='responsavel_celular'
                    model={empresa} />
            </div>

            <div className="col-md-6 mb-3">
                <TextFieldComponent
                    label="E-mail"
                    field='responsavel_email'
                    model={empresa} />
            </div>

        </div>
    );
}

export default EmpresaDadosTab;